// import React, { useState } from "react";
// import { Container, Button, Badge, Card, Tabs, Tab } from "react-bootstrap";
// import { FaHome, FaSignOutAlt, FaUsers, FaCog } from "react-icons/fa";
// import AdminTeamManager from "./AdminTeamManager";
// import AdminHomeManager from "./AdminHomeManager";
// import ServicesAdmin from "./ServicesAdmin";
// import AdminProjects from "./AdminProjects";
// import AdminGallary from "./AdminGallary";
// import AdminJobPosting from "./AdminJobPosting";
// import { useNavigate } from "react-router-dom";
// // const API_URL = "http://radheyelectical.atwebpages.com/api/api_handler.php";

// const AdminDashboard = () => {
//   const [activeKey, setActiveKey] = useState("home"); // Main Tab Control
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     localStorage.removeItem("admin_token");
//     navigate("/admin/login");
//   };

//   return (
//     <Container className="mt-5 pt-5 py-5">
//       {/* --- HEADER SECTION --- */}
//       <div className="d-flex justify-content-between align-items-center mt-5 mb-4 pb-3 border-bottom">
//         <div className="d-flex align-items-center">
//           <h2 className="mb-0 fw-bold text-dark">Admin Dashboard</h2>
//           <Badge bg="primary" className="ms-3">
//             {/* v2.0 */}
//           </Badge>
//         </div>
//         <Button
//           variant="outline-danger"
//           className="d-flex align-items-center"
//           onClick={handleLogout}
//         >
//           <FaSignOutAlt className="me-2" /> Logout
//         </Button>
//       </div>

//       {/* --- MAIN NAVIGATION TABS --- */}
//       <Tabs
//         id="admin-tabs"
//         activeKey={activeKey}
//         onSelect={(k) => setActiveKey(k)}
//         className="mb-4 custom-tabs"
//         justify
//       >
//         <Tab
//           eventKey="home"
//           title={
//             <span>
//               <FaHome className="me-2" />
//               Home Page
//             </span>
//           }
//         >
//           <AdminHomeManager />
//         </Tab>

//         <Tab
//           eventKey="team"
//           title={
//             <span>
//               <FaUsers className="me-2" />
//               About Us
//             </span>
//           }
//         >
//           <div className="mt-4">
//             <AdminTeamManager />
//           </div>
//         </Tab>

//         <Tab
//           eventKey="Service Page"
//           title={
//             <span>
//               <FaUsers className="me-2" />
//               Service Page
//             </span>
//           }
//         >
//           <div className="mt-4">
//             {" "}
//             <ServicesAdmin />{" "}
//           </div>
//         </Tab>
//         <Tab
//           eventKey="Project Page"
//           title={
//             <span>
//               <FaUsers className="me-2" />
//               Project Page
//             </span>
//           }
//         >
//           <div className="mt-4">
//             <AdminProjects />
//           </div>
//         </Tab>

//         <Tab
//           eventKey="Gallery Page"
//           title={
//             <span>
//               <FaUsers className="me-2" />
//               Gallery Page
//             </span>
//           }
//         >
//           <div className="mt-4">
//             {" "}
//             <AdminGallary />{" "}
//           </div>
//         </Tab>

//         <Tab
//           eventKey="Career Page"
//           title={
//             <span>
//               <FaCog className="me-2" />
//               Career Page
//             </span>
//           }
//         >
//           <Card className="border-0 shadow-sm text-center">
//             <AdminJobPosting />
//           </Card>
//         </Tab>
//         <Tab
//           eventKey="Inquiry Page"
//           title={
//             <span>
//               <FaUsers className="me-2" />
//               Inquiry Page
//             </span>
//           }
//         >
//           <div className="mt-4">{/* <AdminTeamManager /> */}</div>
//         </Tab>
//       </Tabs>
//     </Container>
//   );
// };

// export default AdminDashboard;
import React, { useState } from "react";
import {
  Container,
  Button,
  Badge,
  Card,
  Tabs,
  Tab,
  Dropdown,
  Form,
} from "react-bootstrap";
import {
  FaHome,
  FaSignOutAlt,
  FaUsers,
  FaCog,
  FaProjectDiagram,
  FaImages,
  FaBriefcase,
  FaQuestionCircle,
} from "react-icons/fa";
import AdminTeamManager from "./AdminTeamManager";
import AdminHomeManager from "./AdminHomeManager";
import ServicesAdmin from "./ServicesAdmin";
import AdminProjects from "./AdminProjects";
import AdminGallary from "./AdminGallary";
import AdminJobPosting from "./AdminJobPosting";
import AdminInquiries from "./AdminInquiries";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const [activeKey, setActiveKey] = useState("home");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin/login");
  };

  // Mapping keys to labels and icons for easy rendering in both formats
  const navItems = [
    { key: "home", label: "Home Page", icon: <FaHome /> },
    { key: "team", label: "About Us", icon: <FaUsers /> },
    { key: "Service Page", label: "Service Page", icon: <FaCog /> }, // Changed icon for variety
    { key: "Project Page", label: "Project Page", icon: <FaProjectDiagram /> },
    { key: "Gallery Page", label: "Gallery Page", icon: <FaImages /> },
    { key: "Career Page", label: "Career Page", icon: <FaBriefcase /> },
    { key: "Inquiry Page", label: "Inquiry Page", icon: <FaQuestionCircle /> },
  ];

  const renderContent = () => {
    switch (activeKey) {
      case "home":
        return <AdminHomeManager />;
      case "team":
        return (
          <div className="mt-4">
            <AdminTeamManager />
          </div>
        );
      case "Service Page":
        return (
          <div className="mt-4">
            <ServicesAdmin />
          </div>
        );
      case "Project Page":
        return (
          <div className="mt-4">
            <AdminProjects />
          </div>
        );
      case "Gallery Page":
        return (
          <div className="mt-4">
            <AdminGallary />
          </div>
        );
      case "Career Page":
        return (
          <Card className="border-0 shadow-sm  text-center">
            <AdminJobPosting />
          </Card>
        );
      case "Inquiry Page":
        return <AdminInquiries />;
      default:
        return <AdminHomeManager />;
    }
  };

  return (
    <Container className="mt-5 pt-4 py-5">
      {/* --- HEADER SECTION --- */}
      <div className="d-flex justify-content-between align-items-center mt-5 mb-4 pb-3 border-bottom">
        <div>
          <h2 className="mb-0 fw-bold text-dark">Admin Dashboard</h2>
          <Badge bg="primary" pill className="mt-1">
            Management Portal
          </Badge>
        </div>
        <Button
          variant="outline-danger"
          className="d-flex align-items-center"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="me-2" />{" "}
          <span className="d-none d-sm-inline">Logout</span>
        </Button>
      </div>

      {/* --- MOBILE NAVIGATION (Dropdown) --- */}
      <div className="d-md-none mb-4">
        <Form.Group>
          <Form.Label className="small fw-bold text-uppercase text-muted">
            Navigate To:
          </Form.Label>
          <Dropdown onSelect={(k) => setActiveKey(k)} className="w-100">
            <Dropdown.Toggle
              variant="white"
              className="w-100 d-flex justify-content-between align-items-center border shadow-sm py-2"
            >
              <span className="d-flex align-items-center">
                {navItems.find((i) => i.key === activeKey)?.icon}
                <span className="ms-2">
                  {navItems.find((i) => i.key === activeKey)?.label}
                </span>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100 shadow-sm">
              {navItems.map((item) => (
                <Dropdown.Item
                  key={item.key}
                  eventKey={item.key}
                  active={activeKey === item.key}
                >
                  <span className="me-2">{item.icon}</span> {item.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Form.Group>
      </div>

      {/* --- DESKTOP NAVIGATION (Tabs) --- */}
      <div className="d-none d-md-block">
        <Tabs
          id="admin-tabs"
          activeKey={activeKey}
          onSelect={(k) => setActiveKey(k)}
          className="mb-4 custom-tabs"
          justify
        >
          {navItems.map((item) => (
            <Tab
              key={item.key}
              eventKey={item.key}
              title={
                <span>
                  {item.icon}
                  <span className="ms-2">{item.label}</span>
                </span>
              }
            />
          ))}
        </Tabs>
      </div>

      {/* --- RENDER SELECTED COMPONENT --- */}
      <div className="tab-content-wrapper">{renderContent()}</div>
    </Container>
  );
};

export default AdminDashboard;
